import * as API from 'SDK/api'

export const models = {
    'Classic/In-Cycle': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/In-Cycle',
                description: '(auto-generated) In-Cycle Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"In-Cycle"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Downtime': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Downtime',
                description: '(auto-generated) Downtime Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Downtime"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Downtime Reason': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Downtime Reason',
                description: '(auto-generated) Downtime Reason Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Downtime Reason"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Downtime Comment': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Downtime Comment',
                description:
                    '(auto-generated) Downtime Comment Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Downtime Comment"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Downtime Category': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Downtime Category',
                description:
                    '(auto-generated) Downtime Category Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Downtime Category"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Downtime User': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Downtime User',
                description: '(auto-generated) Downtime User Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Downtime User"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Part Count': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Part Count',
                description: '(auto-generated) Part Count Data Collection',
                modelType: 'Event',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Part Count"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimestamp',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'Timestamp',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Reject': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Reject',
                description: '(auto-generated) Reject Data Collection',
                modelType: 'Event',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Reject"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimestamp',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'Timestamp',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Rework': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Rework',
                description: '(auto-generated) Rework Data Collection',
                modelType: 'Event',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Rework"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimestamp',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'Timestamp',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Devices': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Devices',
                description: '(auto-generated) Devices Data Collection',
                modelType: 'Static',
                classic: true,
                dataCollection: 'devices',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'PrimaryID',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Static Hourly Targets': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Static Hourly Targets',
                description:
                    '(auto-generated) Static Hourly Targets Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Hourly Target"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'Classic/Scheduled Targets': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'Classic/Scheduled Targets',
                description:
                    '(auto-generated) Scheduled Targets Data Collection',
                modelType: 'State',
                classic: true,
                dataCollection: 'states',
                query: '{"name":"Scheduled Target"}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'name',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'deviceId',
                description: 'deviceId',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeStart',
                description: 'timeStart',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timeEnd',
                description: 'timeEnd',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'value',
                description: 'value',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'System/Saved Reports': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'System/Saved Reports',
                description: '(auto-generated) Saved Reports Data Collection',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'report_name',
                description: 'Unique name for report',
                type: 'PrimaryID',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'report_configuration',
                description: 'filters, columns, groups, timerange, etc.',
                type: 'TextArea',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'body',
                description: 'api request body',
                type: 'TextArea',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'chart_config',
                description: 'google charts chart builder configuration',
                type: 'TextArea',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'column_config',
                description: 'column configuration',
                type: 'TextArea',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'System/Post Processor/Flows': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'System/Post Processor/Flows',
                description: '(auto-generated) Post Processor Flows Collection',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'name',
                description: 'Unique name for flow',
                type: 'PrimaryID',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'description',
                description: 'description',
                type: 'TextArea',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'System/Kanban Settings': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'System/Kanban Settings',
                description: '(auto-generated) Kanban Settings Collection',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'model_id',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'status_field_path',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'title_field_path',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'description_field_path',
                description: '',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'System/Calendar Settings': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'System/Calendar Settings',
                description: '(auto-generated) Calendar Settings Collection',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'model_id',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'title_field_path',
                description: 'What text to display on calendar events',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'resource_field_path',
                description: 'Calendar resource',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'event_background_color',
                description: 'Default calendar background color',
                type: 'Color',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'MES/Parts': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'MES/Parts',
                description: '(auto-generated) MES Part Information',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'partNumber',
                description: 'Part name or number to identify part',
                type: 'Text',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'hourlyTarget',
                description: 'Hourly target of chosen part number',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'MES/Operators': async () => {
        let dataModel = await API.post(
            'data-models',
            {
                name: 'MES/Operators',
                description: '(auto-generated) MES Operator List',
                modelType: 'Static',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'firstName',
                description: 'First name of operator',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'lastName',
                description: 'Last name of operator',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'username',
                description: 'Username of operator',
                type: 'Text',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'employeeId',
                description: 'Employee id of operator',
                type: 'Text',
                unique: true,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'MES/Machine Entry': async () => {
        let dataModelsList = await API.get('data-models', 2)
        const classicDevicesModel = dataModelsList.find(
            (d) => d.name === 'Classic/Devices'
        )
        const mesOperatorsModel = dataModelsList.find(
            (d) => d.name === 'MES/Operators'
        )
        const mesPartsModel = dataModelsList.find((d) => d.name === 'MES/Parts')

        let dataModel = await API.post(
            'data-models',
            {
                name: 'MES/Machine Entry',
                description: '(auto-generated) MES Machine Entry',
                modelType: 'State',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'asset',
                description: 'asset',
                type: 'ForeignID',
                foreignAliasPath: 'name',
                foreignDataModelId: classicDevicesModel._id,
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'operator',
                description: 'operator',
                type: 'ForeignID',
                foreignAliasPath: 'username',
                foreignDataModelId: mesOperatorsModel._id,
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'parts',
                description: 'Parts count made since last entry',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'rejects',
                description: 'Reject count since last entry',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'partNumber',
                description: 'Part name or number to identify part',
                type: 'ForeignID',
                foreignAliasPath: 'partNumber',
                foreignDataModelId: mesPartsModel._id,
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'earnedHours',
                description: 'Number of earned hours worked',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'timestamp',
                description: 'timestamp',
                type: 'DesignatedTimeStart',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'time_end',
                description: 'autopopulated through flow',
                type: 'DesignatedTimeEnd',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )
    },
    'MES/FPY/Injection Molding': async () => {
        let dataModelsList = await API.get('data-models', 2)
        const classicDevicesModel = dataModelsList.find(
            (d) => d.name === 'Classic/Devices'
        )

        let dataModel = await API.post(
            'data-models',
            {
                name: 'MES/FPY/Injection Molding',
                description: '(auto-generated) MES FPY for Injection Molding',
                modelType: 'Event',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'date',
                description: 'timestamp',
                type: 'DesignatedTimestamp',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'asset',
                description: 'asset',
                type: 'ForeignID',
                foreignAliasPath: 'name',
                foreignDataModelId: classicDevicesModel._id,
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'operator',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'material',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'productionOrder',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'qtyProduced',
                description: '',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'toolCavities',
                description: '',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'activeCavities',
                description: '',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'flash',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'flowMarkWeld',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'marble',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'shortShot',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'splay',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'contamination',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'sinks',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'comments',
                description: '',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
    'MES/FPY/Metal Fabrication': async () => {
        let dataModelsList = await API.get('data-models', 2)
        const classicDevicesModel = dataModelsList.find(
            (d) => d.name === 'Classic/Devices'
        )

        let dataModel = await API.post(
            'data-models',
            {
                name: 'MES/FPY/Metal Fabrication',
                description: '(auto-generated) MES FPY for Metal Fabrication',
                modelType: 'Event',
                classic: false,
                dataCollection: 'datamodeldata',
                query: '{}',
                protectedModel: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'date',
                description: 'timestamp',
                type: 'DesignatedTimestamp',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'asset',
                description: 'asset',
                type: 'ForeignID',
                foreignAliasPath: 'name',
                foreignDataModelId: classicDevicesModel._id,
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'operator',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'material',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'productionOrder',
                description: '',
                type: 'Text',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'qtyProduced',
                description: '',
                type: 'Number',
                unique: false,
                required: true,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'burrs',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'damaged',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'brokenPin',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'scrap',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'incorrectStamp',
                description: '',
                type: 'Number',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )

        await API.patch(
            `data-models/${dataModel._id}/add-field`,
            {
                name: 'comments',
                description: '',
                type: 'Text',
                unique: false,
                required: false,
                protectedField: true,
            },
            2
        )
    },
}
